import { IRequestListValue } from 'common/schema/request/Request';
import { FormikContextType, getIn } from 'formik';
import { DropResult } from 'react-beautiful-dnd';

/**
 * Effettuo il riordinamento delle righe dopo il drag & drop avviato dall'utente e aggiorno di conseguenza lo stato di formik
 */
export function handleDragAndDrop(
  rows: IRequestListValue,
  result: DropResult,
  metadataId: string,
  formik: FormikContextType<any>
) {
  if (!result.destination || !rows) return;

  // Rimappo l'ordine delle righe
  const nextFields = Array.from(rows);
  const [removed] = nextFields.splice(result.source.index, 1);
  nextFields.splice(result.destination.index, 0, removed); // prettier-ignore
  formik.setFieldValue(`values.${metadataId}`, nextFields); // prettier-ignore

  // Rimappo l'ordine del touch delle righe per la validazione
  const nextTouched = Array.from(getIn(formik.touched, `values.${metadataId}`)); // prettier-ignore
  const [removedTouched] = nextTouched.splice(result.source.index, 1);
  nextTouched.splice(result.destination.index, 0, removedTouched); // prettier-ignore
  formik.setFieldTouched(`values.${metadataId}`, nextTouched as any,false) // prettier-ignore
}
